"use client"
import { ItineraryDayV2 } from '@/types/itinerary/itineraryV2'
import React, { useState } from 'react'
import Image from "next/image";
import ItineraryStarIcon from "@/components/icons/ItineraryStarIcon";
import ImageLoading from "@/components/ImageLoading";
import ItineraryTicketIcon from "@/components/icons/ItineraryTicketIcon";
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { useItineraryMapStore } from '@/core/stores/itinerary';
import { generateColor } from '@/utils/generateColor';

const NEXT_PUBLIC_STORAGE_URL = process?.env.NEXT_PUBLIC_STORAGE_URL;

export default function ItineraryDay({ itinerary, index }: { itinerary: ItineraryDayV2, index: number; }) {

    const [open, setOpen] = useState(false);

    const { setModalData }
        = useItineraryMapStore()

    return (
        <div
            className="flex flex-col gap-3 transition-all pl-5  overflow-y-clip duration-300 bg-white">

            <div className={`flex justify-between z-20 relative bg-white p-2 pl-0 w-full ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>

                <span
                    style={{ background: generateColor(index + 1) }}
                    className={`absolute ${index === 0 ? "!top-0" : ""}
                                     ${index % 2 === 0 ? 'top-4' : 'top-10'}
                                 -left-[27px] z-20 shadow size-3 
                                 rounded-full bg-main-500`}
                />

                <div className="flex flex-col w-8/12">
                    <p className='font-semibold text-gray-800 text-[20px]'>{itinerary.dayTitle}</p>
                    <span className="text-xs text-gray-500 mt-2">{itinerary.items.length || 0} Item</span>
                    <p className="text-gray-800 font-normal text-sm mt-2">{itinerary.dayOverview}</p>
                </div>

                <div className="!size-28 relative ">
                    {itinerary.items.slice(0, 3).map((item, index) => (
                        <div
                            key={item.id}
                            className={`${index === 0 ? "!h-24 !w-20 rotate-6 -top-2 -left-2" : index === 1 ? "top-5 left-2 !size-20" : index === 2 ? "-rotate-12 !size-20 right-2" : ""} shadow absolute bg-white p-[2px] rounded-2xl`}>
                            <ImageLoading
                                isActivity
                                type={item.type}
                                className={`rounded-2xl object-cover size-full`}
                                alt={'Planingo'}
                                src={item?.images?.[0]}
                                width={100}
                                height={100}
                            />
                        </div>

                    ))}
                </div>

            </div>

            <div
                className={`${open
                    ? 'flex opacity-100 translate-y-0 scale-100'
                    : 'opacity-0 scale-95 pointer-events-none size-0'
                    } transition-all duration-300 ease-in-out z-10 transform flex-col gap-3`}>
                {itinerary.items.map((item) => (
                    <div
                        onClick={() => {
                            setModalData(item)
                        }}
                        className="flex gap-3 min-w-20 cursor-pointer hover:scale-105 transition-all duration-200"
                        key={item.id}>
                        <ImageLoading
                            isActivity
                            type={item.type}
                            className="!size-20 shadow min-w-20 rounded-2xl object-cover"
                            alt={'Planingo'}
                            src={item?.images?.[0]}
                            width={100}
                            height={100}
                        />
                        <div className="flex flex-col justify-between py-1">
                            <p className="text-[#1E2939] text-[16px] font-semibold line-clamp-1">{item.name}</p>

                            <div className="flex items-center text-xs gap-2">
                                <ItineraryStarIcon />
                                <p className="text-gray-700">{item.rate}<span className="text-gray-500 ml-1">{`(${item.review?.length || 0} reviews)`}</span></p>
                            </div>

                            <div className="flex mt-1 items-center gap-2">
                                <ItineraryTicketIcon />
                                <p className="text-gray-800  font-bold">$ {item.price}</p>
                            </div>

                        </div>
                    </div>
                ))}
            </div>

            <button onClick={() => setOpen(!open)} className={`bg-secondary-50 transition-all duration-500 cursor-pointer z-20 h-10 rounded-lg text-secondary-500`}>
                {open ? 'Show Less' : 'Show More'}
            </button>
        </div>
    )
}
